var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEarRingL2 = function SvgEarRingL2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 26,
    height: 32,
    viewBox: "0 0 0.55 0.68",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#000;stroke-width:.11;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256}.fil0{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2310832533392"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.47.14C.4.02.09-.01.08.27c0 .07 0 .13.01.18m.15.13h.03C.33.6.48.6.5.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.23.25C.3.22.45.3.34.34.28.36.28.41.38.41c.01 0 .03.01.04.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.12.51C.03.57.15.65.18.56.19.53.16.52.14.51c0 0-.02-.01-.02 0zM0 .57C-.01.53.01.48.07.44.09.42.11.42.14.42c.01 0 .03.01.04.02h.01c.05.02.1.05.07.14C.24.65.2.68.15.68.11.69.08.68.05.66A.193.193 0 0 1 0 .57z",
    fill: "#000"
  })))));
};

export default SvgEarRingL2;